import { render, staticRenderFns } from "./UserSummary.vue?vue&type=template&id=24048c4c"
import script from "./UserSummary.vue?vue&type=script&lang=js"
export * from "./UserSummary.vue?vue&type=script&lang=js"
import style0 from "./UserSummary.vue?vue&type=style&index=0&id=24048c4c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports